module.exports = __webpack_public_path__ + "static/media/logoo.cefaef95.png";